import React from "react";
import Grid from "@material-ui/core/Grid";
import Link from "../components/Link";
import { get } from "lodash";

export default function TryptychSlice(slice) {
  const renderItems = (items) => {
    return items.map((el, i) => {
      const image = get(el, "image");
      const link = get(el, "link");

      if (!get(image, "url")) {
        return false;
      }

      const img = <img src={image.url} alt={get(image, "alt") || ""} />;

      return (
        <Grid item key={i} className="tryptych-item" xs={12} sm={4}>
          {link && (link.url || link.uid) ? (
            <Link
              to={"/" + get(el, "link.uid")}
              url={get(el, "link.url")}
              target={get(el, "link.target")}
            >
              {img}
            </Link>
          ) : (
            img
          )}
        </Grid>
      );
    });
  };

  return (
    <section className="tryptych-slice standard-padding-less">
      <div className="wrapper">
        <Grid container className="tryptych-items">
          {renderItems(get(slice, "items", []))}
        </Grid>
      </div>
    </section>
  );
}
